import { useEffect, useRef, useState } from "react";
import { ChevronDown, LogOut, Settings, UserCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import ProfileAvatar from "@/components/profile/ProfileAvatar";

export default function ProfileMenu({ name, photoUrl, profileTo, settingsTo, onLogout, testId = "profile-menu" }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => { if (event.key === "Escape" || (event.type === "mousedown" && !root.current?.contains(event.target))) setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", close); };
  }, [open]);
  return (
    <div ref={root} className="relative">
      <button type="button" onClick={() => setOpen((value) => !value)} className="flex min-h-11 items-center gap-2 rounded-full px-2 py-1 hover:bg-brand-soft" aria-haspopup="menu" aria-expanded={open} data-testid={testId}>
        <ProfileAvatar photoUrl={photoUrl} name={name} size="header"/>
        <span className="max-w-[9rem] truncate text-sm font-medium text-brand-ink">{name || "Min profil"}</span>
        <ChevronDown size={14} className={open ? "rotate-180 text-brand-green" : "text-brand-muted"}/>
      </button>
      {open && (
        <div role="menu" className="absolute right-0 z-50 mt-2 w-52 overflow-hidden rounded-xl border border-brand-line bg-white py-1 shadow-xl">
          <MenuItem to={profileTo} icon={<UserCircle2 size={15}/>} onClick={() => setOpen(false)}>Min profil</MenuItem>
          <MenuItem to={settingsTo} icon={<Settings size={15}/>} onClick={() => setOpen(false)}>Indstillinger</MenuItem>
          <div className="my-1 border-t border-brand-line"/>
          <button type="button" role="menuitem" onClick={onLogout} className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm text-[#991B1B] hover:bg-[#FFF1EF]"><LogOut size={15}/> Log ud</button>
        </div>
      )}
    </div>
  );
}
function MenuItem({ to, icon, onClick, children }) {
  return <Link role="menuitem" to={to} onClick={onClick} className="flex items-center gap-2 px-3 py-2.5 text-sm text-brand-ink hover:bg-brand-soft">{icon}{children}</Link>;
}

